__turbopack_context__.v({
  "changeOwnerModal": "ChangeOwnerModal-module__-FIEjq__changeOwnerModal",
  "loadingContainer": "ChangeOwnerModal-module__-FIEjq__loadingContainer",
  "menuItem": "ChangeOwnerModal-module__-FIEjq__menuItem",
});
